module.exports = __webpack_public_path__ + "f45df0ac189fa377f84b265bade41b82.png";